import React from 'react';
import './App.css';
import { VictoryBar } from "victory";
import { VictoryScatter } from "victory";
import { VictoryErrorBar } from "victory";
import { VictoryBoxPlot } from "victory";
import { VictoryChart } from "victory";
import { VictoryAxis } from "victory";
import { VictoryLegend } from "victory";
import jStat from 'jStat';

export default class Chart extends React.Component {
  constructor(props) {
    super(props)
    this.state = { dataForChart : props.dataForChart, };
    this.prettyListOfCategories = [
      {name: 'Mouse - Achilles', symbol: {fill: '#4e5fca', type: 'square'} },
      {name: 'Mouse - Forepaw Flexors', symbol: {fill: '#9C27B0', type: 'square'} },
      {name: 'Mouse - Patellar', symbol: {fill: '#7CB342', type: 'square'} },
      {name: 'Mouse - Supra', symbol: {fill: '#FDD835', type: 'square'} },
      {name: 'Rat - Achilles', symbol: {fill: '#29B6F6', type: 'square'} },
      {name: 'Rat - Forepaw Flexors', symbol: {fill: '#ffb3ff', type: 'square'} },
      {name: 'Rat - Patellar', symbol: {fill: '#99e699', type: 'square'} },
      {name: 'Rat - Supra',symbol: {fill: '#ffff99', type: 'square'} },
    ]

    this.categoryColors = {
      Mouse_Achilles : '#4e5fca',
      Mouse_ForepawFlexors : '#9C27B0',
      Mouse_Patellar : '#7CB342',
      Mouse_Supra : '#FDD835',
      Rat_Achilles : '#29B6F6',
      Rat_ForepawFlexors : '#ffb3ff',
      Rat_Patellar : '#99e699',
      Rat_Supra : '#ffff99',
    }
  }

  transformGeneForChart(gene){
    var geneForChart = {}

    var scatter_points = []
    var bar_points = []
    var error_bar_points = []
    var box_plot_points = []

    this.props.listOfCategories.forEach(function(category){
      var values = []

      var numbers = ['1', '2', '3', '4']
      numbers.forEach(function(i){
        var key = category + '_' + i
        if (gene[key] !== '') {
          values.push(gene[key])
          scatter_points.push({x: category, y: gene[key]})
        }
      })

      // console.log('values for category', category, values)
      if (values.length == 0) {
        box_plot_points.push({ x: category, min: 0.1, median: 0.1, max: 0.1, q1: 0.1, q3: 0.1 })
      } else {
        var avg = values.reduce((a,b) => a + b, 0) / values.length
        bar_points.push({x: category, y: avg})

        var quartiles = jStat.quantiles(values, [0.25, 0.5, 0.75])
        var interQuartileRange = quartiles[2] - quartiles[0]
        box_plot_points.push({ x: category, min: quartiles[0] - interQuartileRange*(1.5), median: quartiles[1], max: quartiles[2] + interQuartileRange*(1.5), q1: quartiles[0], q3: quartiles[2] })

        var stdev = jStat.stdev(values)
        var lower_confidence = avg - 2*stdev
        var upper_confidence = avg + 2*stdev
        error_bar_points.push({x: category, y: (upper_confidence + lower_confidence)/2, error: Math.abs((upper_confidence - lower_confidence)/2)})
      }
    })

    geneForChart['scatter_points'] = scatter_points
    geneForChart['bar_points'] = bar_points
    geneForChart['error_bar_points'] = error_bar_points
    geneForChart['box_plot_points'] = box_plot_points

    return geneForChart
  }
  
  render() {
    var gene = this.transformGeneForChart(this.props.dataForChart);

    return(
      <VictoryChart
        domainPadding={30}
      >
        <VictoryAxis dependentAxis 
          label={"log2 CPM"}
          // padding={{ top: 20, bottom: 60, left: 600, right: 600 }}
          style={{
            // axis: {stroke: "#756f6a"},
            axisLabel: {fontSize: 10, padding: 30},
            // grid: {stroke: ({ tick }) => tick > 0.5 ? "red" : "grey"},
            // ticks: {stroke: "grey", size: 5},
            tickLabels: {fontSize: 10, padding: 5}
          }}
        />
        <VictoryAxis 
          tickFormat={() => ''} 
          // tickValues={['Mouse', 'Rat']}  // This breaks things
          domain={[0, 11]}
        />
        <VictoryLegend x={310} y={60}
          // title="Legend"
          // centerTitle

          orientation="vertical"
          gutter={20}
          symbolSpacer={7}
          style={{ 
            labels: {fontSize: 10 } 
            // data: {}
            // border: { stroke: "black" }, 

          }}
          padding={50}
          data={this.prettyListOfCategories}
        />
        <VictoryBoxPlot
          boxWidth={20}
          data={gene['box_plot_points']}
          // data={gene['scatter_points']} // It's possible to use either of these ^^
          animate={{
              duration: 400,
              onLoad: { duration: 2000 }
            }}

          boxWidth={10}
          whiskerWidth={10}

          style={{
            // min: { stroke: "tomato" },
            // max: { stroke: "orange" },
            // q1: { fill: ({ datum }) => this.categoryColors[datum.x] },
            // q3: { fill: ({ datum }) => this.categoryColors[datum.x] },
            q1: { 
              fill: '#E1E1E1' , 
              stroke: "#000000",
                      strokeWidth: 0.5,
            },
            q3: { 
              fill: '#E1E1E1' , 
              stroke: "#000000",
                      strokeWidth: 0.5,
            },

            median: { stroke: "white", strokeWidth: 2 },
            // minLabels: { fill: ({ datum }) => this.categoryColors[datum.x] },
            // maxLabels: { fill: ({ datum }) => this.categoryColors[datum.x] }
          }}
        />
        <VictoryScatter
          style={{
            data: {
              fill: ({ datum }) => this.categoryColors[datum.x],
              stroke: "#000000",
              strokeWidth: 0.5,
            }
          }}

          size={2.5}
          data={gene['scatter_points']}
          animate={{
            duration: 400,
            onLoad: { duration: 2000 }
          }}
        />
      </VictoryChart>
    );
    
  }
   // <VictoryErrorBar
   //        // {x: "Mouse_Achilles", y: 4, error: 0.2} Each data point here should look like this, where 'y' and 'error' have been derrived from upper_confidence and lower_confidence
   //        data={gene['error_bar_points']}
   //        errorY={(datum) => datum.error}
   //        width={40}
   //        animate={{
   //          duration: 400,
   //          onLoad: { duration: 2000 }
   //        }}
   //      />


}